import { render } from "./VisaElectronIcon.vue?vue&type=template&id=3f72783f"
import script from "./VisaElectronIcon.vue?vue&type=script&lang=js"
export * from "./VisaElectronIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__